import React from 'react';

import { Box, HStack } from '@chakra-ui/react';

import { WithResourceIcon } from 'components/DataDisplay';
import { CustomSpinner } from 'components/DataDisplay/Spinner/CustomSpinner';
import { IconType } from 'components/Icons';

export interface MetaHeaderWithIconProps {
  iconType?: IconType;
  iconBGColor?: string;
  label?: React.ReactNode;
  header?: React.ReactNode;
  totalCount?: number;
  isLoading?: boolean;
  iconFilled?: boolean;
}

export const MetaHeaderWithIcon = (props: MetaHeaderWithIconProps) => {
  const {
    iconType,
    label,
    iconBGColor,
    totalCount = null,
    isLoading = false,
    iconFilled,
    header: customHeader,
  } = props;

  const content = customHeader ?? (
    <HStack flex={iconType ? 1 : undefined}>
      <HStack spacing={0}>
        <Box fontWeight={600}>{label}</Box>
        <Box>{totalCount !== null && ':'}</Box>
      </HStack>
      {totalCount !== null && (
        <Box>
          {isLoading ? <CustomSpinner loading={isLoading} /> : totalCount}
        </Box>
      )}
    </HStack>
  );

  return iconType ? (
    <WithResourceIcon
      resourceType={iconType}
      bgColor={iconBGColor}
      iconFilled={iconFilled}
    >
      {content}
    </WithResourceIcon>
  ) : (
    content
  );
};
